import "ngstorage";

import {REFERENCE_SCREENS} from "./variables";

class ReferencesController {
  constructor(
    $localStorage,
    $scope,
    $rootScope,
    $state,
    $stateParams,
    AuthService,
    EnvService,
    SecurityService,
    $timeout,
    TrackingService,
    events,
    ngProgressFactory,
    $location,
    companies
  ) {
    this.name = "references";

    this.$localStorage = $localStorage;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$progress = ngProgressFactory.createInstance();
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.$location = $location;
    this.$companies = companies;
    this.referenceScreens = REFERENCE_SCREENS;
    this.sessionData = {};

    this.GoNextListener = this.$rootScope.$on("SendToNextReferenceScreen", ($event, params) => {
      this.handleGoNext(params.referenceScreen);
    });

    this.$scope.$on("$destroy", this.GoNextListener);
  }

  $onInit() {
    //TODO: Check for user token and if detected, log user out
    this.getQuestionsFromAPI();
    this.getReferenceDataFromAPI(this.$location.$$search.rid);
    this.parseUrlForPage(this.$location);
  }

  parseUrlForPage(location) {
    if (location.$$path === "/references/question-one") {
      this.referenceScreen = this.referenceScreens.QUESTION_ONE;
    } else if (location.$$path === "/references/question-two") {
      this.referenceScreen = this.referenceScreens.QUESTION_TWO;
    } else if (location.$$path === "/references/question-three") {
      this.referenceScreen = this.referenceScreens.QUESTION_THREE;
    } else if (location.$$path === "/references/question-four") {
      this.referenceScreen = this.referenceScreens.QUESTION_FOUR;
    } else if (location.$$path === "/references/question-five") {
      this.referenceScreen = this.referenceScreens.QUESTION_FIVE;
    } else if (location.$$path === "/references/question-six") {
      this.referenceScreen = this.referenceScreens.QUESTION_SIX;
    } else if (location.$$path === "/references/confirmation") {
      this.referenceScreen = this.referenceScreens.CONFIRMATION;
    } else {
      this.referenceScreen = this.referenceScreens.WELCOME_SCREEN;
    }
  }

  handleGoNext(prevState) {

    let nextState = prevState;

    console.log("handleGoNext");
    console.dir(prevState);
    console.dir(this.event);
    console.dir(REFERENCE_SCREENS);

    switch (prevState) {
      case REFERENCE_SCREENS.WELCOME_SCREEN:
        nextState = REFERENCE_SCREENS.QUESTION_ONE;
        this.$state.transitionTo("references-question-one", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_ONE:
        nextState = REFERENCE_SCREENS.QUESTION_TWO;
        this.$state.transitionTo("references-question-two", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_TWO:
        nextState = REFERENCE_SCREENS.QUESTION_THREE;
        this.$state.transitionTo("references-question-three", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_THREE:
        nextState = REFERENCE_SCREENS.QUESTION_FOUR;
        this.$state.transitionTo("references-question-four", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_FOUR:
        nextState = REFERENCE_SCREENS.QUESTION_FIVE;
        this.$state.transitionTo("references-question-five", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_FIVE:
        nextState = REFERENCE_SCREENS.QUESTION_SIX;
        this.$state.transitionTo("references-question-six", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.QUESTION_SIX:
        nextState = REFERENCE_SCREENS.CONFIRMATION;
        this.$state.transitionTo("confirmation", {rid: this.sessionData.rid}, {notify: false});
      case REFERENCE_SCREENS.CONFIRMATION:
        nextState = REFERENCE_SCREENS.QUESTION_SIX;
        this.$state.transitionTo("references-question-six", {rid: this.sessionData.rid}, {notify: false});
        break;
      case REFERENCE_SCREENS.POSTCONFIRMATION:
        nextState = REFERENCE_SCREENS.CONFIRMATION;
        this.$state.transitionTo("confirmation", {rid: this.sessionData.rid}, {notify: false});
        break;
    }

    this.setWalkthroughState(nextState);
  }

  setWalkthroughState(state) {
    this.$timeout(() => {
      this.referenceScreen = state;
    });
  }

  getQuestionsFromAPI() {
    this.$security.getReferenceQuestions().then(
      (response) => {
        this.sessionData.questions = response.data;
      },
      (error) => {
        console.log("error");
        console.dir(error);
        alert("error getting questions");
      }
    );
  }

  getReferenceDataFromAPI(rid) {

    if (!rid) {
      console.error("No reference ID provided");
      return;
    }

    this.setLoader();
    this.$security.getReferenceDataFromAPI(rid).then(
      (response) => {
        this.setSessionData(response.data);
      },
      (error) => {
        console.log("error");
        console.dir(error);
        alert("error getting reference id");
        this.unSetLoader();
      }
    );
  }

  setSessionData(data) {
    try {
      this.sessionData.rid = data.userReference.userReferenceId;
      this.sessionData.referenceType = data.userReference.referenceType;
      this.sessionData.jobblerFullName = data.jobblerName;
      this.sessionData.userData = {};
      this.sessionData.userData.firstName = data.userReference.firstName;
      this.sessionData.userData.lastName = data.userReference.lastName;
      this.sessionData.companyName = data.userReference.company;
    } catch (e) {
      //alert("error loading reference ID");
    } finally {
      this.unSetLoader();
    }
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }
}

ReferencesController.$inject = [
  "$localStorage",
  "$scope",
  "$rootScope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
  "ngProgressFactory",
  "$location",
  "companies",
];

export default ReferencesController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/references.controller.js